export default "__VITE_ASSET__LK$C4mXo__"